
export const InputGoodsHeaders=[
    {
        "label":"ITEM",
        "value":"item",
        "defaultChecked":true,
        "checked":true
    },
    {
        "label":"LOCATION",
        "value":"location",
        "defaultChecked":true,
        "checked":true
    },
    {
        "label":"QTY",
        "value":"quantity",
        "defaultChecked":true,
        "checked":true
    },
    {
        "label":"RATE",
        "value":"rate",
        "defaultChecked":true,
        "checked":true
    },
    {
        "label":"AMOUNT",
        "value":"amount",
        "defaultChecked":true,
        "checked":true
    }
]

export const OutputGoodsHeaders=[
    {
        "label":"ITEM",
        "value":"item",
        "defaultChecked":true,
        "checked":true,
        "width":"168px"
    },
    {
        "label":"LOCATION",
        "value":"location",
        "defaultChecked":true,
        "checked":true,
        "width":"158px"
    },
    {
        "label":"QTY",
        "value":"quantity",
        "defaultChecked":true,
        "checked":true,
        "width":"40px"
    },
    {
        "label":"COST ALLOCATION(%)",
        "value":"percentageOfCostAllocation",
        "defaultChecked":true,
        "checked":true,
        "width":"95px"
    },
    {
        "label":"RATE",
        "value":"rate",
        "defaultChecked":true,
        "checked":true,
        "width":"100px"
    },
    {
        "label":"AMOUNT",
        "value":"amount",
        "defaultChecked":true,
        "checked":true,
        "width":"100px"
    }
]

export const InputGoodDataInput={
    itemName:{
        label:"Select...",
        value:"",
        unit:""
    },
    location:{
        label:"Select...",
        value:""
    },
    batchNumber:{
        label:"Select...",
        value:""
    },
    manufacturingDate:"",
    expiryDate:"",
    batchInputOptions:[],
    quantity:1,
    rate:"",
    amount:"",
    stocks:"",
    isOpen:false
}

export const OutputGoodDataInput={
    itemName:{
        label:"Select...",
        value:"",
        unit:""
    },
    location:{
        label:"Select...",
        value:""
    },
    quantity:1,
    percentOfCostAllocation:"",
    rate:"",
    amount:"",
    stocks:"",
    type:"",
    isOpen:false
}

export const BomHeaderDataInput={
    documentNumber:"",
    date:"",
    primaryItem:{
        label:"Select...",
        value:""
    },
    branch:{
        label:"Select...",
        value:""
    },
    batchNumber:{
        label:"Select...",
        value:""
    },
    qty:"",
    rate:"",
    amount:"",
    stocks:""
}

export const BomHeaderDataError={
    dateError:false,
    primaryItemError:false,
    branchError:false,
    qtyError:false
}

export const BomInstallationInput={
    itemName:"",
    percentage:"",
    price:"",
    isEditable:true
}